import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

const FundingEnquiryActionsRecord = Record({
  description: '',
  id: 0,
  name: '',
});

export default class FundingEnquiryActions extends FundingEnquiryActionsRecord {
  static deserialize(jsonObject = {}) {
    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, {}), {});

    return new FundingEnquiryActions(hydrated);
  }
}
